import React, { ReactNode } from 'react';
import { Space } from 'antd';
import { StyledTitle } from '../StyledTitle';
import { RoundedCard } from '../styledComponents';

type TitledRoundedCardProps = {
  title: string;
  numbering: string | number;
  children: ReactNode;
};

export const TitledRoundedCard = ({ children, title, numbering }: TitledRoundedCardProps): JSX.Element => {
  return (
    <RoundedCard
      title={
        <Space align="center" size="middle">
          <StyledTitle level={3} type="secondary">
            {numbering}
          </StyledTitle>
          <StyledTitle level={4}>{title}</StyledTitle>
        </Space>
      }
    >
      {children}
    </RoundedCard>
  );
};
